import apiClient from "./apiClient";
import { TrackingItem } from "../types/tracking";

const TRACKINGS_PATH = "tracking";

function extractTrackingList(body: unknown): TrackingItem[] {
  const raw = (body ?? {}) as Record<string, unknown>;
  if (Array.isArray(raw)) return raw as TrackingItem[];
  if (Array.isArray(raw.data)) return raw.data as TrackingItem[];
  const nested = raw.data as Record<string, unknown> | undefined;
  if (nested && Array.isArray(nested.filtered)) {
    return nested.filtered as TrackingItem[];
  }
  if (Array.isArray(raw.filtered)) return raw.filtered as TrackingItem[];
  return [];
}

function extractTrackingItem(body: unknown): TrackingItem {
  const raw = (body ?? {}) as Record<string, unknown>;
  if (raw.id && raw.trackingId) return raw as unknown as TrackingItem;

  const nested = raw.data as Record<string, unknown> | undefined;
  if (nested) {
    // GET /tracking/:id → { status, data: { filtered: { ...tracking } } }
    const filtered = nested.filtered;
    if (filtered && typeof filtered === "object" && !Array.isArray(filtered)) {
      const item = filtered as Record<string, unknown>;
      if (item.id) return item as unknown as TrackingItem;
    }
    if (nested.id && nested.trackingId) {
      return nested as unknown as TrackingItem;
    }
  }

  return raw as unknown as TrackingItem;
}

export const getTrackings = async (
  search = "",
  status = ""
): Promise<TrackingItem[]> => {
  try {
    const params: Record<string, string> = {};
    if (search) params.search = search;
    if (status) params.status = status;

    const response = await apiClient.get(TRACKINGS_PATH, { params });
    return extractTrackingList(response.data);
  } catch (error) {

    throw error;
  }
};

export const getTrackingById = async (id: string): Promise<TrackingItem> => {
  try {
    const response = await apiClient.get(`${TRACKINGS_PATH}/${id}`);
    return extractTrackingItem(response.data);
  } catch (error) {

    throw error;
  }
};

export const createTracking = async (shipmentId: string): Promise<void> => {
  try {
    await apiClient.post(`${TRACKINGS_PATH}/${shipmentId}/create`);
  } catch (error) {

    throw error;
  }
};

export const updateTrackingStatus = async (
  trackingId: string,
  newStatus: string
): Promise<void> => {
  await apiClient.patch(`${TRACKINGS_PATH}/status`, {
    trackingId,
    newStatus,
  });
};

export const deleteTrackingById = async (id: string): Promise<void> => {
  try {
    await apiClient.delete(`${TRACKINGS_PATH}/${id}`);
  } catch (error) {

    throw error;
  }
};
